import React from 'react';

type Props = {
    size?: {
        width: number;
        height: number;
    };
};

export const PowerPointIcon = ({size = {width: 32, height: 40}}: Props) => {
    return (
        <svg width={size.width} height={size.height} viewBox='0 0 32 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M1.59518 10.3571L10.4929 1.57645C10.8672 1.20709 11.3718 1 11.8977 1H28C29.6569 1 31 2.34315 31 4V36C31 37.6569 29.6569 39 28 39H4C2.34315 39 1 37.6569 1 36V11.7806C1 11.2456 1.21437 10.7329 1.59518 10.3571Z'
                stroke='#ED522A'
                strokeWidth='2'
            />
            <path d='M11 2V11C11 11.5523 10.5523 12 10 12H2' stroke='#ED522A' strokeWidth='2' />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M19.8317 25.7059C20.6106 25.0219 21 24.0342 21 22.7428C21 21.5007 20.6343 20.5664 19.903 19.9398C19.1716 19.3133 18.1036 19 16.699 19H13V31H15.4554V26.7319H16.5089C17.9452 26.7319 19.0528 26.3899 19.8317 25.7059ZM16.2634 24.6471H15.4554V21.0848H16.5723C17.2429 21.0848 17.7353 21.2271 18.0495 21.5116C18.3637 21.7962 18.5208 22.2367 18.5208 22.8331C18.5208 23.4241 18.3333 23.8742 17.9584 24.1833C17.5835 24.4925 17.0185 24.6471 16.2634 24.6471Z'
                fill='#ED522A'
            />
        </svg>
    );
};
